import { useState } from 'react';
import { categories } from '@/mocks/movies';
import { useNavigate } from 'react-router-dom';

export default function CategoryTabs() {
  const [active, setActive] = useState('all');
  const navigate = useNavigate();

  const handleCategoryClick = (slug: string) => {
    setActive(slug);
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="w-full px-4 md:px-8 py-6 md:py-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg md:text-xl font-heading text-foreground-100">
            影片分类
          </h3>
        </div>
        <div className="flex items-center gap-1.5 md:gap-2 flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => handleCategoryClick(cat.slug)}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${
                active === cat.slug
                  ? 'bg-primary-500 text-background-950 font-medium'
                  : 'bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200/60 border border-background-300/30'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}